import { SystemDetailData } from "../systemsStep/SystemsStep.types";
import { useDotLegalPostGetQueryArray } from "@common/hooks/dotLegalReactQuery";

export function useSystemDetailsQuery(systemIds: Array<string>) {
    const hasIds = systemIds.length > 0;
    return useDotLegalPostGetQueryArray<Array<SystemDetailData>>(["systemDetails", ...systemIds], "/system/details", systemIds, {
        enabled: hasIds,
    });
}
